module.exports = __webpack_public_path__ + "static/media/assistencia24h.11a2261a.png";